const HEADER_SCROLL_VALUE = 50;
const HEADER_FULL_SCROLL_VALUE = 80;
export const SOCIALBAR_FIXED_SCROLL_VALUE = 35;

export { HEADER_SCROLL_VALUE, HEADER_FULL_SCROLL_VALUE };
